import { Box } from "./box.model";

export class Shelf {
    box: Box;
    shelfStart: number;
}